import { clickBodyNode } from "@/data/pubilc";

const showPreinstall: Ref<boolean> = ref<boolean>(false);

const preinstallList: any = reactive([]);

const clickThemeInput = () => {
  if (!showPreinstall.value) {
    showPreinstall.value = true;
  }
};

const getPreinstall = async () => {
  const list: object = import.meta.glob("./*.js");
  const preinstall = Object.keys(list).map((item: string) => {
    const name = item.slice(item.lastIndexOf("/") + 1, item.lastIndexOf("."));
    return {
      title: name,
    };
  });
  preinstallList.splice(0, preinstallList.length, ...preinstall);
};

watch(clickBodyNode, () => {
  showPreinstall.value = false;
});

export { showPreinstall, preinstallList, getPreinstall, clickThemeInput };
